/**
 * Collection of categories
 * 
 * @class Collection_Categories
 */

Collection_Categories = (function (BaseCollection) {
    var Collection_Categories = function () {
        this.construct.apply(this, arguments);
    };

    $.extend(true, Collection_Categories.prototype, BaseCollection.prototype, {
		/**
		 * @inheriteddoc Collection#fetch
		 * @returns promise
		 */
        fetch: function (params) {
            return new Promise(function (resolve, reject) {
                this.config.reqParams = (params ? params.reqParams : this.config.reqParams) || this.config.reqParams;
                this.reset();

                var p1 = API.fetchAllCategories()
                    .bind(this)
                    .then(function (resp) {
                        if (resp) {
                            var jsonObj = JSON.parse(resp);
                            this.parseData(jsonObj.data.flexApplication.categories);
                        } else {
                            reject();
                        }
                    })
                    .catch(function (err) {
                        App.throbberHide();
                        App.notification(__(err));
                        reject();
                    });

                var p2 = API.fetchFavorites();
                var p3 = API.fetchContinueWatching();

                Promise.all([p1, p2, p3]).then(values => {
                    this.parseExtraData(values[1].data.favourites, __('favorites'), false);
                    this.parseExtraData(values[2].data.userVideoTimesByUser, __('continue_watching'), true);
                    resolve();
                });

                
            }.bind(this))
        },

		/**
		 * parsing response to collection
		 * @param {Array of object} data
		 */
        parseData: function (data, scene, snippet) {
            var items = (data instanceof Array) ? data : data.items || [],
                item;
            for (var i = 1; i < items.length; i++) {
                item = items[i];
                this.push(item);
                // added reference to the order
                this.models[i-1].data.relId = i-1;
            }
            
        },

        parseExtraData: function (data, name, filterVideos) {
            console.log(data);
            if (data.length > 0){
                var vidArray = new Array();
                if(filterVideos){
                    for(var i = 0; i < data.length; i++) {
                        vidArray.push(data[i].video);
                    }
                } else { vidArray = data;}
                var item = {name: name, videos: vidArray};
                var modelLength = this.models.length;
                this.push(item);
                this.models[modelLength].data.relId = modelLength;
            }
        },

		/**
		 * To get Model specified by given id
		 * @param {String} id of asset
		 * @returns {Model} 
		 */
        getById: function (id) {
            for (var i = 0; i < this.models.length; i++) {
                if (this.models[i].getID() == id) {
                    return this.models[i];
                }
            }
            return false;
        }

    });

    return Collection_Categories;
})(BaseCollection);



//////////////////
// WEBPACK FOOTER
// ./js/collection/collection_categories.js
// module id = 6
// module chunks = 0